import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocalization } from '../contexts/LocalizationContext';

// Lists the countries the store operates in, but the shopper is locked to the one
// currently selected in the storefront (change it with the country selector).
const LockedCountrySelect = ({ id = 'country', className = '' }) => {
  const { i18n } = useTranslation();
  const { countryCode, availableCountries } = useLocalization();

  const options = useMemo(() => {
    let names = null;
    try { names = new Intl.DisplayNames([i18n.language || 'en'], { type: 'region' }); } catch (e) { /* fall back to API names */ }
    const list = availableCountries.some((c) => c.code === countryCode)
      ? availableCountries
      : [...availableCountries, { code: countryCode, name: countryCode }];
    return list.map((c) => ({ code: c.code, label: names?.of(c.code) || c.name }));
  }, [availableCountries, countryCode, i18n.language]);

  return (
    <select
      id={id}
      name="country"
      value={countryCode || ''}
      disabled
      aria-readonly="true"
      data-testid="locked-country-select"
      className={`h-9 w-full cursor-not-allowed rounded-md border border-input bg-gray-50 px-3 py-1 text-base text-gray-700 shadow-sm md:text-sm ${className}`}
    >
      {options.map((o) => (
        <option key={o.code} value={o.code}>{o.label}</option>
      ))}
    </select>
  );
};

export default LockedCountrySelect;
